import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { SelectedAddressType } from "src/common/libs/types/EditProfileScreen";

export interface AddressState {
  selected: SelectedAddressType;
}

const initialState: AddressState = {
  selected: null,
};

export const selectedAddressSlice = createSlice({
  name: "selectedAddress",
  initialState,
  reducers: {
    setSelectedAddress: (state, action: PayloadAction<SelectedAddressType>) => {
      state.selected = action.payload;
    },
    clearData: () => initialState,
  },
});

export const { setSelectedAddress, clearData } = selectedAddressSlice.actions;

export default selectedAddressSlice.reducer;
